import React from "react";

export default function Footer() {
  return (
    <footer className="relative bottom-0 z-50 w-full py-4 md:py-8 bg-mesanfaz-gray">
      <div className="max-w-screen-xl mx-auto text-center">
        <span className="text-gray-500  sm:text-center">
          © 2025 - Made with ❤️ and 🎧️
        </span>
      </div>
    </footer>
  );
}
